import React from 'react';

import { string, oneOf, bool } from 'prop-types';

import { LazyLoadImage as LazyImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

/**
 *
 * @param {string} src Source link of the image
 * @param {string} alt alt tag of the image
 * @param {string} className class defined for the image itself
 * @param {string} effect - effect type for lazy loading
 * @param {boolean} showEffect - boolean that decides whether we show effect or not to lazy load
 */
const LazyLoadImage = ({ src, alt, className, effect, showEffect }) => (
  <LazyImage
    src={src}
    alt={alt}
    className={className}
    effect={showEffect && effect}
  />
);

LazyLoadImage.propTypes = {
  src: string.isRequired,
  alt: string.isRequired,
  className: string.isRequired,
  effect: oneOf(['blur', 'black-and-white', 'opacity']),
  showEffect: bool,
};

LazyLoadImage.defaultProps = {
  effect: 'blur',
  showEffect: true,
};

export default LazyLoadImage;
